define([
  'redux',
  'es6!launcher/reducers/AppReducers',
  'es6!launcher/actions/ListBuilderActions',
  'es6!launcher/actions/ShortcutsActions',
  'react-monkey',
], (redux, AppReducers, ListBuilderActions, ShortcutsActions, ReactMonkey) => {
  let hasDispatchedValidate = false;

  function thunkMiddleware({ dispatch, getState }) {
    return next => (action) => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      return next(action);
    };
  }

  // This middleware dispatches a validation event on all actions that
  // each reducer can subscribe to for validations.
  function validationMiddleware({ dispatch, getState }) {
    return next => (action) => {
      // Prevent infinite loop by not validating validate actions.
      if (
        !hasDispatchedValidate &&
        action.type !== ListBuilderActions.VALIDATE &&
        action.type in ListBuilderActions
      ) {
        // Limiting the validations to one per js event loop.
        hasDispatchedValidate = true;
        // We need a setTimeout since we are in a dispatch currently.
        setTimeout(() => {
          hasDispatchedValidate = false;
          dispatch({ type: ListBuilderActions.VALIDATE, fullState: getState() });
        }, 0);
      }

      if (action.type !== ShortcutsActions.VALIDATE_SHORTCUT && action.type in ShortcutsActions) {
        setTimeout(() => {
          dispatch({ type: ShortcutsActions.VALIDATE_SHORTCUT, fullState: getState() });
        });
      }

      return next(action);
    };
  }

  let profileMiddleware;

  if (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'production') {
    profileMiddleware = () => next => action => next(action);
  } else {
    profileMiddleware = () => next => (action) => {
      ReactMonkey.recordEventStart('redux', action.type, action, action);
      const result = next(action);
      ReactMonkey.recordEventStop('redux', action.type, action, action);

      return result;
    };
  }

  const store = redux.compose(
    redux.applyMiddleware(thunkMiddleware),
    redux.applyMiddleware(validationMiddleware),
    redux.applyMiddleware(profileMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  )(redux.createStore);

  return store(AppReducers);
});
